import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Callout, FlexGap, Modal, Paragraph, Subheading } from '@treams/treams-ui';

interface IProps {
	saving: boolean;
	onConfirm: () => Promise<unknown> | unknown;
	onClose: () => void;
}

export function ConversationRevealEmptySaveConfirm({ saving, onConfirm, onClose }: IProps) {
	const { t } = useTranslation();
	const [error, setError] = useState(false);

	const handleConfirm = async () => {
		setError(false);
		try {
			await onConfirm();
			onClose();
		} catch {
			setError(true);
		}
	};

	return (
		<Modal width={450}>
			<Modal.Contents>
				<Subheading>{t('conversations.reveal.upload.emptySaveTitle')}</Subheading>
				<Paragraph mt={2}>{t('conversations.reveal.upload.emptySaveDescription')}</Paragraph>
				{error ? (
					<Callout color="red" mt={3}>
						{t('conversations.reveal.upload.emptySaveError')}
					</Callout>
				) : null}
			</Modal.Contents>
			<Modal.Footer>
				<FlexGap gap={8} justifyContent="flex-end" alignItems="center" width="100%">
					<Button
						small
						type="alternative"
						title={t('common.cancel')}
						disabled={saving}
						onClick={onClose}
					/>
					<Button
						small
						type="destructive"
						title={t('conversations.reveal.upload.emptySaveConfirm')}
						loading={saving}
						onClick={handleConfirm}
					/>
				</FlexGap>
			</Modal.Footer>
		</Modal>
	);
}
